__turbopack_context__.v({
  "categoriesPillContainer": "wCEaLW_categoriesPillContainer",
  "slideInAnimation": "wCEaLW_slideInAnimation",
});
